export type LimitValue = string | number | null

export enum LimitType {
    DEPOSIT = 'depositLimits',
    LOSS = 'lossLimits',
}

export type LimitTypeUnion = `${LimitType}`

export enum PromptType {
    SIGNUP = 'SIGNUP',
    PLAY = 'PLAY',
}

export type PromptTypeUnion = `${PromptType}`

export enum Requirement {
    SINGLE = 'SINGLE',
    OPTIONAL = 'OPTIONAL',
}

export type RequirementUnion = `${Requirement}`

export enum Period {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
}

export type PeriodUnion = `${Period}`
export type LowercasePeriod = Lowercase<Period>
export type LowercasePeriodUnion = `${LowercasePeriod}`
export type CapitalizedPeriod = Capitalize<LowercasePeriod>
export type CapitalizedPeriodUnion = Capitalize<CapitalizedPeriod>

export enum InputType {
    SLIDERS = 'sliders',
    INPUTS = 'inputs',
}

export type InputTypeUnion = `${InputType}`

export enum SetBy {
    EMPLOYEE = 'EMPLOYEE',
    PLAYER = 'PLAYER',
}

export type SetByUnion = `${SetBy}`

export interface Config {
    enabled: boolean
    pendingHours: number
    prompt: PromptType
    requirement: Requirement
    requiresUserConfirmation: boolean
    type: LimitType
    userHasAnyLimit: boolean
    canPendingBeConfirmed: boolean
}

export interface Slider {
    max: string | 'inf'
    min: string
    steps: (number | 'inf')[]
}

export interface Limit {
    period: Period
    type: LimitType
    setBy: SetBy
    value: string
    remaining: string
    setAt: string | null
    expiresAt: string | null
    hasSoftExpiry: boolean
    pendingValue: string | null
    pendingUntil: string | null
    canBeConfirmed: boolean
}

export interface LimitStatuses {
    limits: Limit[]
}

export type SliderOptions = {
    [K in Period]: Slider
}

export type Limits = {
    [K in Period]: Limit
}

export type LimitData = {
    [K in Period]: LimitValue
}

export interface MutatingLimit {
    active: boolean
    period: Period
    value: LimitValue
}

export type MutatingLimits = {
    [K in Period]: MutatingLimit
}

export type ValidationError = {
    message: string
    type: 'error' | 'warning'
}

export type ValidationErrors = {
    [K in Period]: ValidationError | null
}
